import { createReducer, on } from '@ngrx/store';

import { DashboardNavigationActionsUnion } from '../actions/dashboard-navigation.actions';
import { DashboardNavigationActions } from '../actions';

import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export interface DashboardNavigationState {
  isNextButtonClicked: boolean;
  isBackButtonClicked: boolean;
  isTemporaryChange: boolean;

  navCommands?: KeyValueDict<string>;
}

export const initialState: DashboardNavigationState = {
  isNextButtonClicked: false,
  isBackButtonClicked: false,
  isTemporaryChange: false,

  navCommands: {
    next: null,
    prev: null
  }
};

const dashboardNavigationReducer = createReducer(
  initialState,
  on(DashboardNavigationActions.nextButtonClicked, state => ({...state, isNextButtonClicked: true})),
  on(DashboardNavigationActions.backButtonClicked, state => ({...state, isBackButtonClicked: true})),
  on(DashboardNavigationActions.resetButtons, state => ({...state, isNextButtonClicked: false, isBackButtonClicked: false})),
  on(DashboardNavigationActions.setupNavigation, (state, {navCommands}) => ({...state, navCommands}))
);

export function reducer(state: DashboardNavigationState | undefined, action: DashboardNavigationActionsUnion) {
  return dashboardNavigationReducer(state, action);
}
